import { Link } from 'react-router-dom';
import styled from 'styled-components';
import theme from 'styled-theming';
import Theme from '../../constants/Theme';

const Head = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  background: ${theme('mode', Theme.botBar.bg)};
`;

const Left = styled.div``;

const Right = styled.div`
  padding: 0 5px;
  justify-self: end;
`;

const LogoLink = styled(Link)`
  width: 114px;
  height: 20px;
  padding: 10px;
  display: block;
`;

const Logo = styled.img`
  width: 114px;
  height: 20px;
`;

const StyledLink = styled(Link)`
  color: ${theme('mode', Theme.botBar.link)};
  text-decoration: none;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export { Head, Left, Right, LogoLink, Logo, StyledLink };



// WEBPACK FOOTER //
// ./src/components/UI/TopBarUI.tsx